import App from 'app/app.js';

function SpecialCharacterValidationFilter() {
  return function (value) {
    var regex = /[~`@$%^_+=}\]>{\[</:;"'\\|]+/g;
    var valid = true;
    if (!!value && value.trim()) {
      valid = !regex.test(value);
    }
    return valid;
  };
}

App.filter('SpecialCharacterValidationFilter', [SpecialCharacterValidationFilter]);
